import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import PessoaFisica from "../../assets/navbar/Pessoa_fisica_on_light_blue.svg";
import Convenios from "../../assets/navbar/Convenios_on.svg";
import Agentes from "../../assets/navbar/Agentes_on.svg";
import Regional from "../../assets/navbar/Regional_on.svg";
import Lojas from "../../assets/navbar/Lojas_on.svg";
import LupaOn from "../../assets/navbar/Lupa_on.svg";

import Button from "../../components/Button";
import SkeletonListItem from "../SkeletonListItem";

import api from "../../services/api";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import { set } from "lodash";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListPF({ history, pageFilter, filter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [estado, setestado] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [PESSOA_FISICA, setPf] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(0);

  const [orderDirection, setorderDirection] = useState("ASC");
  const [orderByColumn, setorderByColumn] = useState("nome");
  const [sortIndex, setSortIndex] = useState(0);

  async function getDataByPJcnpj(cpfCnpj, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `api/pessoa/buscar?cpfCnpjOuNome=${
          cpfCnpj || ""
        }&tipoPessoa=PESSOA_FISICA&page=${
          page || 0
        }&size=${pageLimit}&sort=${orderByColumn},${orderDirection}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setPf(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setPage(page || 0);
        setPf([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar as pessoas físicas.");
      }

      setIsLoading(false);
    } catch (err) {
      setPage(page || 0);
      setTotalPages(0);
      setTotalElements(0);
      setPf([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar as pessoas físicas.");
      }
    }
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    loadUser(filter, pageFilter);
  }, [filter, pageFilter, pageLimit, sortIndex]);

  async function loadUser(cpfCnpj, page) {
    getDataByPJcnpj(cpfCnpj, page);
  }

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter)}${
        page && page > 0 ? "&page=" + page : ""
      }`
    );
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage(value);
    }
  };

  const verifyIfIsEnabled = (pessoaJuridica, entity, image, url) => {
    if (!pessoaJuridica || pessoaJuridica === null) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (
      pessoaJuridica &&
      (!pessoaJuridica?.tipoEntityPessoa ||
        pessoaJuridica?.tipoEntityPessoa === null)
    ) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (pessoaJuridica && pessoaJuridica?.tipoEntityPessoa) {
      let pessoaJuridicaSearched = pessoaJuridica?.tipoEntityPessoa.find(
        (x) => x.papelPessoaJuridica === entity
      );
      if (pessoaJuridicaSearched && pessoaJuridicaSearched !== null) {
        return (
          <S.SvgIcon
            onClick={() => {
              history.push(`/${url}`);
            }}
            src={image}
            alt=""
          />
        );
      }
    }

    return <S.SvgIconDisabled src={image} alt="" />;
  };

  const selectNumberRegistry = async (item) => {
    setPageLimit(item.id);
  };

  const selectSort = async (item) => {
    setSortIndex(item.id);

    switch (item.sort) {
      case "DESC":
        setorderByColumn("nome");
        setorderDirection("DESC");
        break;
      case "ASC":
        setorderByColumn("nome");
        setorderDirection("ASC");
        break;
      case "DataDESC":
        setorderByColumn("data_registro");
        setorderDirection("DESC");
        break;
      case "DataASC":
        setorderByColumn("data_registro");
        setorderDirection("ASC");
        break;
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <div className="boxSearch">
            <S.SvgIcon src={LupaOn} className="lupa" />
            <InputMask
              type="text"
              name="search"
              alwaysShowMask={false}
              value={search}
              onKeyPress={(e) => handleKeyPress(e)}
              onChange={(ev) => setSearch(ev.target.value)}
            />
            <Button type="button" onClick={() => reloadPage(search)}>
              Buscar por CPF ou nome
            </Button>
          </div>
          <S.CardHeader>
            <div className="numeroCadastros">
              <span>
                {`${totalElements} ${totalElements > 1 ? "" : ""} cadastro${
                  totalElements > 1 ? "s" : ""
                } no sistema`}
              </span>
            </div>
            <div className="msg">
              {totalElements > 0 && (
                <span className="border">
                  Selecione o icone para acessar o cadastro
                </span>
              )}
            </div>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {PESSOA_FISICA &&
                PESSOA_FISICA?.map((PESSOA_FISICA) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(
                              `/cadastro-pessoa-fisica/${PESSOA_FISICA?.id}`
                            )
                          }
                        >
                          <S.SvgIcon src={PessoaFisica} alt="" />
                          <div className="dataCard">
                            <h4>CPF:</h4>
                            <h4>Nome:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(
                                PESSOA_FISICA?.cpfCnpj,
                                "###.###.###-##",
                                true
                              )}
                            </h4>
                            <h4 className="h4-info">{PESSOA_FISICA?.nome}</h4>
                          </div>
                        </S.Info>

                        <div className="iconService">
                          {verifyIfIsEnabled(
                            PESSOA_FISICA,
                            "LOJA",
                            Lojas,
                            `cadastro-lojas/${PESSOA_FISICA?.id}`
                          )}
                          {verifyIfIsEnabled(
                            PESSOA_FISICA,
                            "AGENTE",
                            Agentes,
                            `cadastro-agentes/${PESSOA_FISICA?.id}`
                          )}
                          {verifyIfIsEnabled(
                            PESSOA_FISICA,
                            "REGIONAL",
                            Regional,
                            `cadastro-regionais/${PESSOA_FISICA?.id}`
                          )}
                          {verifyIfIsEnabled(
                            PESSOA_FISICA,
                            "CONVENIO",
                            Convenios,
                            `cadastro-convenios/${PESSOA_FISICA?.id}`
                          )}
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}

              <div className="rodaPe">
                <div className="select1">
                  <S.SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={selectNumberRegistry}
                      initialValue={pageLimit}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  <S.SelectContainer>
                    <BorderForSort
                      selected={0}
                      handleSearch={selectSort}
                      initialValue={sortIndex}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  {totalPages > 1 && (
                    <TablePagination
                      component="div"
                      classes={{
                        toolbar: classes.toolbar,
                        caption: classes.caption,
                      }}
                      count={totalElements}
                      page={page}
                      labelDisplayedRows={({ from, to, count }) => {
                        return from + " - " + to + " de " + count;
                      }}
                      onPageChange={(p, newPage) => reloadPage(search, newPage)}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={pageLimit}
                    />
                  )}
                </div>
              </div>
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
    </>
  );
}
